import { useContext, inlinedQrl, useLexicalScope } from "@builder.io/qwik";
import { dropdownContextId } from "./dropdown-context.qwik.mjs";
function useDropdown() {
  const context = useContext(dropdownContextId);
  const getNextEnabledItemIndex$ = /* @__PURE__ */ inlinedQrl((index) => {
    const [context2] = useLexicalScope();
    let offset = 1;
    const len = context2.itemsMapSig.value.size;
    if (!context2.loop && index + 1 >= len)
      return index;
    while (offset < len) {
      const nextIndex = (index + offset) % len;
      if (!context2.itemsMapSig.value.get(nextIndex)?.disabled)
        return nextIndex;
      offset++;
      if (!context2.loop && index + offset >= len)
        break;
    }
    return index;
  }, "useDropdown_getNextEnabledItemIndex_kdsGJPl1pBg", [
    context
  ]);
  const getPrevEnabledItemIndex$ = /* @__PURE__ */ inlinedQrl((index) => {
    const [context2] = useLexicalScope();
    let offset = 1;
    const len = context2.itemsMapSig.value.size;
    if (!context2.loop && index - 1 < 0)
      return index;
    while (offset <= len) {
      const prevIndex = (index - offset + len) % len;
      if (!context2.itemsMapSig.value.get(prevIndex)?.disabled)
        return prevIndex;
      offset++;
      if (!context2.loop && index - offset < 0)
        break;
    }
    return index;
  }, "useDropdown_getPrevEnabledItemIndex_NuF1F0Y0Xsk", [
    context
  ]);
  const getActiveDescendant$ = /* @__PURE__ */ inlinedQrl((index) => {
    const [context2] = useLexicalScope();
    if (index === -1 || context2.itemsMapSig.value.get(index)?.disabled)
      return "";
    return `${context2.localId}-${index}`;
  }, "useDropdown_getActiveDescendant_tllw5saUh0U", [
    context
  ]);
  return {
    getNextEnabledItemIndex$,
    getPrevEnabledItemIndex$,
    getActiveDescendant$
  };
}
export {
  useDropdown
};
